import React from "react"
import Error from "next/error"
import ArtworksPage from "../../../../features/pages/ArtworksPage"
import galleryApiService from "../../../../services/galleryApiService"

const Artworks = ({ catalog, gallery, errorCode, filters }) => {
  if (errorCode) {
    return <Error statusCode={errorCode} />
  }
  return <ArtworksPage catalog={catalog} gallery={gallery} filters={filters} />
}

export const getServerSideProps = async ({ params }) => {
  const { id } = params

  // If given an ID find the domain and redirect
  const isNumericId = /^\d+$/.test(id)
  if (isNumericId) {
    const response = await galleryApiService
      .gallery(id)
      .catch((err) => err.response)
    if (!response || response.status !== 200) {
      return { notFound: true }
    }
    return {
      redirect: {
        destination: `/galleries/${response.data.domain}/artworks`,
        permanent: true,
      },
    }
  }
  // Otherwise it is the domain
  const response = await galleryApiService
    .galleryByDomain(id)
    .catch((err) => err.response)
  const artworksResponse = await galleryApiService
    .galleryArtworks(response.data.id)
    .catch((err) => err.response)

  const filterResponse = await galleryApiService.artworksfilters()

  const errorCode =
    response.statusText == "OK" && artworksResponse.statusText == "OK"
      ? false
      : response.status

  return {
    props: {
      errorCode: errorCode,
      gallery: response.data,
      catalog: artworksResponse.data,
      filters: filterResponse.data,
    },
  }
}

export default Artworks
